<template>
  <transition name="fade">
    <div id="GoTop" v-show="isVisible" @click="GoTop()">
      <i class="fas fa-arrow-up"></i>
    </div>
  </transition>
</template>
<script>
export default {
  name: "GoTop",
  data() {
    return {
      isVisible: false
    };
  },
  methods: {
    GoTop() {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    },
    handleScroll() {
      this.isVisible = window.scrollY > 300;
    }
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll);
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll);
  }
};
</script>
<style scoped>
#GoTop {
  width: 50px;
  height: 50px;
  position: fixed;
  right: 30px;
  bottom: 30px;
  z-index: 9999;
  cursor: pointer;
  background: var(--primary);
  color: white;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1);
  transition: var(--transition-smooth);
}

#GoTop:hover {
  transform: translateY(-5px);
  background: var(--bg-dark);
  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.2);
}

.fade-enter-active, .fade-leave-active {
  transition: opacity 0.3s;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
}
</style>




// WEBPACK FOOTER //
// src/components/GoTop.vue